/**
 * Files carried by a paste event, for the chat composer.
 *
 * A pasted screenshot (macOS ⌘⌃⇧4 then ⌘V) or a file copied from Finder /
 * Explorer arrives in `clipboardData.files`; some browsers only expose an
 * image through `clipboardData.items` (kind `'file'`). Chrome lists the same
 * file in both, as two *different* File objects whose `lastModified` is the
 * moment each was materialised — a few ms apart for a screenshot, so they
 * cannot be matched up (board 1s4a: every pasted screenshot uploaded twice).
 * `files` is by spec the list of the file items, so the items are only read
 * when `files` is empty.
 */

/** The subset of `DataTransfer` this helper reads (tests build it by hand). */
export interface ClipboardLike {
  files?: ArrayLike<File> | null
  items?: ArrayLike<{ kind: string; getAsFile(): File | null }> | null
}

/** Every file in the clipboard, in clipboard order, each once. */
export function clipboardFiles(data: ClipboardLike | null | undefined): File[] {
  if (!data) return []
  const files = Array.from(data.files ?? [])
  if (files.length > 0) return files
  const out: File[] = []
  for (const item of Array.from(data.items ?? [])) {
    if (item.kind !== 'file') continue
    const file = item.getAsFile()
    if (file) out.push(file)
  }
  return out
}
